module.exports = __webpack_public_path__ + "static/media/1_A1_21.f49215f7.png";